import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ChatbotService } from "../chatbot/chatbot.service";
 
@Component({
  selector: "color-footer",
  templateUrl: "./color-footer.component.html",
  styleUrls: ["./color-footer.component.scss"],
})
export class ColorFooterComponent implements OnInit, AfterViewInit {
  currentYear: any;
  isChatbotOpen: boolean;
  chatMessages: string[];
  shouldShowChatbotIcon: boolean;
 
  constructor(private chatbotService: ChatbotService) {
    this.chatbotService.getChatbotState().subscribe((isOpen) => {
      this.isChatbotOpen = isOpen;
    });
    this.chatMessages = this.chatbotService.getChatMessages();
    this.checkCurrentUrl();
  }
 
  ngOnInit() {
    this.currentYear = new Date().getFullYear();
  }
  ngAfterViewInit(): void {
    window.onscroll = function () {
      if (window.scrollY >= 300) {
        // document.getElementById("myBtn").style.visibility = "visible";
      } else {
        // document.getElementById("myBtn").style.visibility = "hidden";
      }
    };
  }
  goToTopPage() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  }
 
  openChatbot(): void {
    this.chatbotService.toggleChatbotState();
  }
  checkCurrentUrl() {
    const currentUrl = localStorage.getItem("currentURL");
    this.shouldShowChatbotIcon = !currentUrl.includes("ahsgpt");
  }
}